import { array } from "prop-types";
import cx from "classnames";
import { useEffect, useState } from "react";

import useMatchMedia from "../../common/useMatchMedia.js";
import ContentListingItemVariantTwo from "./ContentListingItemVariantTwo.jsx";
import DropdownFacets from "../DropdownFacets/DropdownFacets.jsx";
import FeaturedItem from "./FeaturedItem.jsx";

import { SelectedFacets } from "./SelectedFacets.jsx";

const propTypes = { results: array, facets: array };

const VariantTwo = (props) => {
  const {
    results,
    facets,
    response,
    handleFacetClick,
    clearAllFacets,
    activeFacets,
  } = props;

  // Media queries
  const matchesLarge = useMatchMedia("(min-width: 1024px)");
  const matchesNavigation = useMatchMedia("(min-width: 1200px)");

  // Used to show and hide mobile facets full-screen takeover menu
  const [showMobileFacets, setShowMobileFacets] = useState(false);

  // Keep track of grid vs. list view
  const [view, setView] = useState("grid");

  return (
    <div className="dynamic-content-listing__variant-two-parent">
      <div className="dropdown-facets">
        {matchesNavigation ? (
          // Render desktop version of facet dropdown menus
          <div className="dropdown-facets__left">
            {response?.facets &&
              response?.facets.map((facet, i) => {
                // Putting each facet object in an array to easily work with
                // pre-existing functions in the DropdownFacets component
                const arr = [];
                arr.push(facet);

                return (
                  <DropdownFacets
                    key={i}
                    facets={arr}
                    onFacetClick={handleFacetClick}
                    showFacetsLabel={facet.label}
                    clearAllFacets={clearAllFacets}
                    showDownCaret
                  />
                );
              })}
          </div>
        ) : (
          // Render mobile version of facet dropdown menu
          facets && (
            <DropdownFacets
              facets={facets}
              facetMenuOpen={showMobileFacets}
              setFacetMenuOpen={setShowMobileFacets}
              onFacetClick={handleFacetClick}
              clearAllFacets={clearAllFacets}
              showFacetsLabel="Filters"
              clearAllLabel="Clear all"
              totalResults={response?.totalResults}
              showDownCaret={false}
            />
          )
        )}

        <SelectedFacets
          clearAllLabel="Clear all"
          clearAllFacets={clearAllFacets}
          handleFacetClick={handleFacetClick}
          response={response}
          setShowMobileFacets={setShowMobileFacets}
          showMobileFacets={showMobileFacets}
          activeFacets={activeFacets}
          view={view}
          setView={setView}
        />
      </div>

      <div
        className={cx("dynamic-content-listing__variant-two", {
          "dynamic-content-listing__variant-two--grid":
            view === "grid" && matchesNavigation,
          "dynamic-content-listing__variant-two--list":
            view === "list" && matchesNavigation,
        })}
      >
        {results?.map((result, index) => {
          if (result) {
            switch (result.type) {
              case "feature":
                return <FeaturedItem {...result} key={index} />;
              case "page":
                return (
                  <ContentListingItemVariantTwo
                    displayImage={true}
                    key={index}
                    {...result}
                    variantType={2}
                    columnCount={3}
                    variantTwoView={view}
                  />
                );
              default:
                console.warn(
                  "Result(s) were found without type 'feature' or 'page'. Make sure result items have a 'type'.",
                );
                return;
            }
          } else {
            return;
          }
        })}
      </div>
    </div>
  );
};

VariantTwo.propTypes = propTypes;
export default VariantTwo;
